import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import PostForm from '../PostForm';

class EditPost extends Component {
  render() {
    return (
      <div className="list-wrapper">
        <Typography variant="headline" component="h4">Update post</Typography>
        <PostForm {...this.props}>
          <div className="button-group">
            <Button variant="raised" color="primary" type="save">Update</Button>
            <Button
              component={Link}
              to={`/${this.props.screen}`}
              variant="raised"
              color="secondary"
            >
              Cancel
            </Button>
          </div>
        </PostForm>
      </div>
    )
  }
}

export default EditPost;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/EditPost/index.js